<div class="modal fade">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="mt-10 d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb" (click)="onClickback()">
        <img src="././assets/icon/backArrow.svg" class="cp">
        <label class="font_semibold fs-18 ml-10 mt-5 black_color">
          <span class="cp">Learning & Development
          </span> /
          <span [style.color]="buttonColorName">Setup</span>
        </label>
      </div>
      <div class="modal-body p-20">
        <div class="mt-10">

          <div class="">

            <ion-row>
             
              <!-- <ion-col size-sm="3" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                <div class="formLabelSemiBoldfs16 mb-5">Fiscal Year<span class="red-cl">&nbsp;*</span>
                </div>
                <mat-form-field class="w-80 mat-height40 mat-input-style">

                  <mat-select placeholder="Select Fiscal Year" formControlName="fiscalYear"
                    (selectionChange)="onSelectFiscalYear()">

                    <mat-option *ngFor="let item of fiscalYears" [value]="item">
                      {{ item }}
                    </mat-option>

                  </mat-select>
                </mat-form-field>
              </ion-col> -->
              <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                <div class="formLabelSemiBoldfs16 mb-5">Year<span class="red-cl">&nbsp;*</span>
                </div>
                <mat-form-field class="w-80 mat-height40 mat-input-style">
                  <mat-select placeholder="Select" formControlName="year" (selectionChange)="onSelectYearForPMSSetup()">
                    <mat-option [value]="item.year"
                      *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="attritionSetupForm.controls['year'].hasError('required')">Year
                    is required</mat-error>
                </mat-form-field>
              </ion-col>
            </ion-row>

            <div class="cardBox mb-20 mt-2">
              <div class="cardBoxHeading font_medium fs-14">
                <ion-row class="pl-5">
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="font_bold fs-14">Create Training Effect Rating Scale</div>
                  </ion-col>
                </ion-row>
              </div>
           
              <div class="pl-10">

                <ion-row class="p-0">
                  <ion-col size="6">
                    <ion-row class="ml-2">
                      <ion-col size="12" *ngIf="!isLastMaxRange100(getBucketArray('ageGroupBuckets'))">
                        <div class="font_semibold addnewbtn fs-14 cp"
                          (click)="toggleInputs('ageGroupBuckets')">
                          <!-- + Add New -->
                          {{ ageGroupBucketsInput ? "" : "+ Add Rating Scale" }}
                        </div>
                      </ion-col>
                      
                      <ion-row *ngIf="ageGroupBucketsInput" class="mb-15">
                        <ion-col size="6">
                          <div class="w-100 inputBox notAllowed">{{ scoreRange }}</div>
                        </ion-col>
                        <ion-col size="6">
                          
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="maxRange" type="number" placeholder="Max Range"
                              class="font_regular fs-12" min="1"
                              (input)="onMaxRangeChange({ maxRange: maxRange, minRange: scoreRange })"
                              (keypress)="preventNegative($event)" />
                          </mat-form-field>
                          <div *ngIf="errMsgMaxRange" class="fs-12 red-cl font_regular">Max Range is required</div>
                          <div *ngIf="!errMsgMaxRange && isInValidMaxRange" class="fs-12 red-cl font_regular">Max Range should
                            be greater than Min Range</div>
                        </ion-col>
                        <ion-col size="12" *ngIf="ageGroupBucketsInput">
                          <ion-row>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn fs-14 cp" (click)="saveData()">
                                Save
                              </div>
                            </ion-col>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
                                Remove
                              </div>
                            </ion-col>
                          </ion-row>
                        </ion-col>
                      </ion-row>
                    </ion-row>
                    <div class="table-container">
                      <table class="hover mb-5 custom-table">
                        <thead>
                          <tr>
                            <th class="fs-14 font_bold cl-black">Rating</th>
                            <th class="fs-14 font_bold cl-black">Defination</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of ratingScale">
                            <td class="fs-14 font_regular">{{ item.rating }}</td>
                            <td class="fs-14 font_regular">{{ item.definition }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
                        {{ errorMessage }}
                      </div>
                    </div>
                  </ion-col>

                </ion-row>

              </div>
            </div>


            <!-- Employee nomination process -->

            
            <div class="cardBox mb-20">
              <div class="cardBoxHeading font_medium fs-14">
                <ion-row class="pl-5">
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="font_bold fs-14">Employee nomination process</div>
                  </ion-col>
                </ion-row>
              </div>
              <div class="pl-10">
                <ion-row class="pl-5">
                  <div class="employee-nomination fs-14">Who will nominate employees?</div>
                </ion-row>
                <ion-row>
                  <mat-radio-group  aria-label="Select Status" class="fs-14 font_semibold">
                    <mat-radio-button value="Approved" >
                      Manager
                    </mat-radio-button>
                    <mat-radio-button value="Rejected" class=" pl-10">
                      HOD
                    </mat-radio-button>
                  </mat-radio-group>
                  
                </ion-row>


              </div>
            </div>


            <!-- Training Reaction feedback form  -->

            <div class="cardBox mb-20">
              <div class="cardBoxHeading font_medium fs-14">
                <ion-row class="pl-5">
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="font_bold fs-14">Training Reaction Feedback Form-Employee</div>
                  </ion-col>
                </ion-row>
              </div>
              <div class="pl-10">
                <ion-row>
                  
                  <ion-col size="4">
                    <ion-row class="ml-2">                    
                      <ion-col size="12" *ngIf="!isLastMaxRange100(getBucketArray('performanceBuckets'))">
                        <div class="font_semibold addnewbtn fs-14 cp" *ngIf="!performanceBucketsInput"
                          (click)="toggleInputs('performanceBuckets')">
                          + Add Question
                        </div>
                      </ion-col>
                      
                      <ion-row *ngIf="performanceBucketsInput" class="mb-15">
                        <ion-col size="6">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <mat-select placeholder="Select" formControlName="selectedProgram">
                              <mat-option *ngFor="let question of addQuestionForEmployee" [value]="question.questionType">
                                {{ question.questionType }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ion-col>
                        <ion-col size="6">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="maxRange" type="text" placeholder="Type question..."
                              class="font_regular fs-12" min="1"
                              (input)="onMaxRangeChange({ maxRange: maxRange, minRange: scoreRange })"
                              (keypress)="preventNegative($event)" />
                          </mat-form-field>
                          <div *ngIf="errMsgMaxRange" class="fs-12 red-cl font_regular">Max Range is required</div>
                          <div *ngIf="!errMsgMaxRange && isInValidMaxRange" class="fs-12 red-cl font_regular">Max Range should
                            be greater than Min Range</div>
                        </ion-col>
                        <ion-col size="12" *ngIf="performanceBucketsInput">
                          <ion-row>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn fs-14 cp" (click)="saveData()">
                                Save
                              </div>
                            </ion-col>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
                                Remove
                              </div>
                            </ion-col>
                          </ion-row>
                        </ion-col>
                      </ion-row>
                    </ion-row>
                    <div class="table-container">
                      
                      <table class="hover mb-5 custom-table">
                        <thead>
                          <tr>
                            <th class="fs-14 font_bold cl-black">Question type</th>
                            <th class="fs-14 font_bold cl-black">Question</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of addQuestionForEmployee">
                            <td class="fs-14 font_regular">{{ item.questionType }}</td>
                            <td class="fs-14 font_regular">{{ item.question }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
                        {{ errorMessage }}
                      </div>
                    </div>
                  </ion-col>
                 
                  
                </ion-row>


              </div>
            </div>


            <!-- Training Job learning Feedback Form - Manager -->
            <div class="cardBox mb-20">
              <div class="cardBoxHeading font_medium fs-14">
                <ion-row class="pl-5">
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="font_bold fs-14"> Training Job learning Feedback Form - Manager </div>
                  </ion-col>
                </ion-row>
              </div>
              <div class="pl-10">
                <ion-row>
                
                  <ion-col size="4">
                    <ion-row class="ml-2">        
                      <ion-col size="12" *ngIf="!isLastMaxRange100(getBucketArray('salaryBuckets'))">
                        <div class="font_semibold addnewbtn fs-14 cp" *ngIf="!salaryBucketsInput"
                          (click)="toggleInputs('salaryBuckets')">
                          + Add Question
                        </div>
                      </ion-col>
                      
                      <ion-row *ngIf="salaryBucketsInput" class="mb-15">
                        <ion-col size="6">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <mat-select placeholder="Select" formControlName="selectedProgram">
                              <mat-option *ngFor="let question of addQuestionForManager" [value]="question.questionType">
                                {{ question.questionType }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ion-col>
                        <ion-col size="6">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="maxRange" type="text" placeholder="Type question..."
                              class="font_regular fs-12" min="1"
                              (input)="onMaxRangeChange({ maxRange: maxRange, minRange: scoreRange })"
                              (keypress)="preventNegative($event)" />
                          </mat-form-field>
                          <div *ngIf="errMsgMaxRange" class="fs-12 red-cl font_regular">Max Range is required</div>
                          <div *ngIf="!errMsgMaxRange && isInValidMaxRange" class="fs-12 red-cl font_regular">Max Range should
                            be greater than Min Range</div>
                        </ion-col>
                        <ion-col size="12" *ngIf="salaryBucketsInput">
                          <ion-row>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn fs-14 cp" (click)="saveData()">
                                Save
                              </div>
                            </ion-col>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
                                Remove
                              </div>
                            </ion-col>
                          </ion-row>
                        </ion-col>
                      </ion-row>
                    </ion-row>
                    <div class="table-container">
                    
                      <table class="hover mb-5 custom-table">
                        <thead>
                          <tr>
                            <th class="fs-14 font_bold cl-black">Question type</th>
                            <th class="fs-14 font_bold cl-black">Question</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of addQuestionForManager">
                            <td class="fs-14 font_regular">{{ item.questionType }}</td>
                            <td class="fs-14 font_regular">{{ item.question }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
                        {{ errorMessage }}
                      </div>
                    </div>
                  </ion-col>

                </ion-row>
              </div>
            </div>

     <!-- Training Job Behavior Feedback Form - Manager -->
     <div class="cardBox mb-20">
      <div class="cardBoxHeading font_medium fs-14">
        <ion-row class="pl-5">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="font_bold fs-14"> Training Job Behavior Feedback Form - Manager </div>
          </ion-col>
        </ion-row>
      </div>
      <div class="pl-10">
        <ion-row>
        
          <ion-col size="4">
            <ion-row class="ml-2">        
              <ion-col size="12" *ngIf="!isLastMaxRange100(getBucketArray('salaryBuckets'))">
                <div class="font_semibold addnewbtn fs-14 cp" *ngIf="!salaryBucketsInput"
                  (click)="toggleInputs('salaryBuckets')">
                  + Add Question
                </div>
              </ion-col>
              
              <ion-row *ngIf="salaryBucketsInput" class="mb-15">
                <ion-col size="6">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" formControlName="selectedProgram">
                      <mat-option *ngFor="let question of addQuestionForManager" [value]="question.questionType">
                        {{ question.questionType }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size="6">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <input matInput [(ngModel)]="maxRange" type="text" placeholder="Type question..."
                      class="font_regular fs-12" min="1"
                      (input)="onMaxRangeChange({ maxRange: maxRange, minRange: scoreRange })"
                      (keypress)="preventNegative($event)" />
                  </mat-form-field>
                  <div *ngIf="errMsgMaxRange" class="fs-12 red-cl font_regular">Max Range is required</div>
                  <div *ngIf="!errMsgMaxRange && isInValidMaxRange" class="fs-12 red-cl font_regular">Max Range should
                    be greater than Min Range</div>
                </ion-col>
                <ion-col size="12" *ngIf="salaryBucketsInput">
                  <ion-row>
                    <ion-col size="auto">
                      <div class="font_semibold addnewbtn fs-14 cp" (click)="saveData()">
                        Save
                      </div>
                    </ion-col>
                    <ion-col size="auto">
                      <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
                        Remove
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-col>
              </ion-row>
            </ion-row>
            <div class="table-container">
            
              <table class="hover mb-5 custom-table">
                <thead>
                  <tr>
                    <th class="fs-14 font_bold cl-black">Question type</th>
                    <th class="fs-14 font_bold cl-black">Question</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of addQuestionForManager">
                    <td class="fs-14 font_regular">{{ item.questionType }}</td>
                    <td class="fs-14 font_regular">{{ item.question }}</td>
                  </tr>
                </tbody>
              </table>
              <div *ngIf="errorMessage" class="font_regular fs-12 red-cl">
                {{ errorMessage }}
              </div>
            </div>
          </ion-col>

        </ion-row>
      </div>
    </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</div>